import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SignInComponent } from '../../components/autenticacion/sign-in/sign-in.component';
import { DialogConfirmarComponent } from '../../components/app-base/dialogs/confirmar/dialog-confirmar.component';
import { ExitoComponent } from 'src/app/components/app-base/dialogs/exito/exito.component';
import { FracasoComponent } from 'src/app/components/app-base/dialogs/fracaso/fracaso.component';



@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(
    public dialog: MatDialog,

  ) { }

  dialogConfirmar() {
    return this.dialog.open(DialogConfirmarComponent)
  }

  dialogExito() {
    return this.dialog.open(ExitoComponent)
  }

  dialogFracaso() {
    return this.dialog.open(FracasoComponent)
  }


}


